module.exports = __webpack_public_path__ + "static/cai_services_dronecapture-bd856706cf8ca36efa8dae8662610e81.png";